module.exports = __webpack_public_path__ + "static/banner03artichokes-ce942c7ce617ef266b858b3f8198216f.jpg";